import { render, staticRenderFns } from "./OverlayCart.vue?vue&type=template&id=84d85b00&"
import script from "./OverlayCart.vue?vue&type=script&lang=js&"
export * from "./OverlayCart.vue?vue&type=script&lang=js&"
import style0 from "./OverlayCart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports